import React from "react";
import { Modal } from "reactstrap";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import Spinner from "reactstrap/lib/Spinner";
import { base_url } from "assets/utils/const";
class AgreementDoc extends React.Component {
  state = {
    companyName: "",
    companyAddress: "",
    firstName:  '',
    lastName: '',
    isLoaded: false,
    isChecked: false,
    authToken: localStorage.getItem("Authtoken"),
    meId: "",
  };

  componentDidMount() {
    if (!localStorage.getItem("Authtoken")) {
      window.location.href = "/login";
    }
    fetch(`${base_url}api/dmoAuthApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: this.state.authToken,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("result", result);
        if (result.statusCode == "200") {
          const payloadDetails = JSON.parse(result.payLoad);
          this.setState({
            firstName: payloadDetails.firstName,
            lastName: payloadDetails.lastName,
            companyName: payloadDetails.companyName,
            companyAddress: payloadDetails.companyAddress,
            meId: payloadDetails.meId,
          });
        } else {
          if (result.payLoad === `Session Expired Please Login`) {
            this.toggleModal("loginModal");
          }
        }
      });
  }

  handleLogin = () => {
    this.toggleModal("loginModal");
    window.location.href = "/login";
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isLoaded: true });

    // var umeid = localStorage.getItem("umeid");

    fetch(`${base_url}api/docSign`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        meId: this.state.meId,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          //alert(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            window.location.href = "/success";
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
          //localStorage.setItem('umail', uname);
        }
      );
  };

  render() {
    return (
      <>
        <section className="dv-Registration-content doc-main-div">
          <div className="container">
            <div className="row">
              <div
                className="col-md-12 form-div1"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <form
                  onSubmit={this.handleSubmit}
                  className="dv-login-form dv-form"
                >
                  <h1 className="section-heading border-heading">Individual</h1>
                  <div className="dv-indicator">
                    <ul className="indicator">
                      <li className="box completed"></li>
                      <li className="line"></li>
                      <li className="box completed"></li>
                      <li className="line pid"></li>
                      <li className="box pid"></li>
                    </ul>
                  </div>
                  <h4 className="text-center doc-txt">
                    Merchant Service Agreement
                  </h4>

                  <div className="agreementContent">
                    <div className="pagebody" style={{ lineHeight: "1.5" }}>
                      <table style={{ width: "100%", marginBottom: "40px" }}>
                        <tbody>
                          <tr>
                            {/* <td>
                              <h6 style={{ fontWeight: "bold" }}>
                                AGREEMENT NUMBER{" "}
                                <span
                                  className
                                  style={{
                                   
                                    width: "auto",
                                    display: "inline-block",
                                    fontWeight: "normal",
                                    lineHeight: 1,
                                  }}
                                >
                                  342342424222
                                </span>
                              </h6>
                            </td> */}
                            <td style={{ textAlign: "right" }}>
                              <h6 style={{ fontWeight: "bold" }}>
                                Date:
                                <span
                                  style={{
                                    width: "auto",
                                    display: "inline-block",
                                    fontWeight: "normal",
                                    lineHeight: 1,
                                  }}
                                >
                                  {new Date().toDateString()}
                                </span>
                              </h6>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {/* <div class=""> */}
                      <ul
                        style={{ listStyleType: "none", padding: 0, margin: 0 }}
                      >
                        <li>
                          This Agreement is entered into by and between{" "}
                          <b>PAYGATE INDIA PVT. LTD.</b> having its office at
                          879, Udyog Vihar, Phase-V, Gurgaon, Haryana- 122016
                          (hereinafter referred to as “Paygate” or “the
                          Company”); and the Merchant listed in{" "}
                          <span
                            className
                            style={{
                              width: "auto",
                              display: "inline-block",
                              fontWeight: "normal",
                              lineHeight: 1,
                            }}
                          >
                            <b>{this.state.companyName}</b>
                          </span>{" "}
                          having its office at{" "}
                          <span
                            className
                            style={{
                              width: "auto",
                              display: "inline-block",
                              fontWeight: "normal",
                              lineHeight: 1,
                            }}
                          >
                            {this.state.companyAddress}
                          </span>
                        </li>
                        <li>
                          <b>
                            THE PARTIES AGREE ON TERMS AND CONDITIONS AS
                            FOLLOWS:
                          </b>
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>1.PURPOSE</b>
                          <br />
                          The Merchant desires to use payments platform service
                          for receiving payment of goods and/or services from
                          customers and for its convenience making payment
                          through available channels including but not limited
                          to credit card, debit card, digital wallet, banking
                          payment,UPI and Other payment Services provided by the
                          Company (“Services”).
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            2.COMMENCEMENT OF SERVICES
                          </b>
                          <br />
                          The Merchant agrees to submit an application form
                          correctly and completely filled in together with
                          supporting documents required by the Company on the
                          date hereof for the Company’s consideration. The
                          Merchant shall be entitled to use the Services for
                          receiving the payments for goods and/or services of
                          the Merchant only upon obtaining the Company’s
                          permission.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            3.ACKNOWLEDGEMENT OF RISKS IN ELECTRONIC
                            TRANSACTIONS
                          </b>{" "}
                          <br />
                          The Merchant has carefully considered and realizes
                          that electronic transactions are of risk and accepts
                          any consequent damages incurred from such electronic
                          transactions. The Merchant agrees to strictly comply
                          with the following:
                          <br />
                          <br />
                          3.1 In case of receipt of the payments for goods
                          and/or services, the Merchant must keep, not less than
                          eighteen (18) months, sales record or proof of trade,
                          delivery of goods/services and receipt of payments
                          such as tax invoice, shipping slip, receipt, etc. as
                          proof in any disputes happen thereafter. If the
                          Company desires to verify the Merchant’s transactions,
                          the Merchant agrees to provide the Company with all
                          relevant information and documents immediately or
                          within a specified period. The Merchant also agrees to
                          assist the Company in order to acquire such
                          information and documents and shall not, in any
                          circumstances, obstruct, weaken, destroy or hinder the
                          Company from acquiring such information and documents.
                          <br />
                          <br />
                          3.2 In case of refusal and/or non-receivable payment,
                          card cancellation or hold, or having a reasonable
                          suspicion cause regarding the dishonest use of debit
                          card/credit card/bank account/wallet or any other
                          reasons causing the Company’s money to be deducted or
                          compensated or claimed as fees, fines, penalties or
                          damages by any banks, financial institutions, card
                          networks or other persons, the Merchant agrees to
                          reimburse to the Company in full amount which and that
                          the Company is entitled to immediately set-off such
                          amount with the amount of payment for goods and/or
                          services payable to the Merchant without any objection
                          or attempt to decline the said responsibility in all
                          respects.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>4.SERVICE FEE</b>
                          <br />
                          4.1 The Company is entitled to the service fee for
                          performance of obligations hereunder according to the
                          rate and payment method specified in the application.
                          <br />
                          <br />
                          4.2 The Merchant agrees that the Company is entitled
                          to immediately set-off the amount of payments for
                          goods and/or services to be transferred to the
                          Merchant by the Company with the amount of service fee
                          including expenses or any other fees that the Merchant
                          is required to pay or reimburse to the Company
                          hereunder prior to transferring such amount to the
                          Merchant.
                        </li>
                        <li>
                          4.3 During the period of this Agreement, upon revision
                          from the Banks, financial institutions or card
                          networks, the Company reserve the right to amend the
                          rate of service fee by giving at least fifteen (15)
                          days advance notice to the Merchant and such notice
                          shall be deemed an integral part of this agreement.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            5.PAYGATE SERVICE
                          </b>
                          <br />
                          5.1 The Company shall gather all the payments for
                          goods and/or services on behalf of the Merchant and,
                          after deducting of the service fee according to Clause
                          4 and any expenses (if any) such as credit card fees,
                          etc., remit it to the Merchant’s account within the
                          specified period and according to the payment method
                          as per the application. The Merchant agrees to be
                          responsible for all fees incurred by such remittance.
                          <br />
                          <br />
                          5.2 In event that funds in the Merchant’s bank account
                          are not sufficient, the Company reserves the right to
                          terminate this Agreement and close the Merchant ID
                          immediately.
                          <br />
                          <br />
                          5.3 The Merchant ID is the user account created by the
                          Company for the Merchant to use Services.
                          <br />
                          <br />
                          5.4 Unless otherwise provided herein, the Company
                          reserves the right to open only one Merchant ID for
                          the Merchant, if it appears that the Merchant has or
                          obtains more than one Merchant ID, the Company is
                          entitled to cancel other Merchant ID(s) and retain
                          only one of them for the Merchant.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            6.PAYGATE SERVICE
                          </b>
                          <br />
                          6.1 The Merchant has a duty to deliver information of
                          goods and/or services according to form and method as
                          stipulated by the Company immediately when customers
                          make an order of goods and/or services.
                          <br />
                          <br />
                          6.2 The Merchant represents and warrants that any
                          information delivered to the Company, under Clause 6.1
                          of this Agreement, is correct. The Company shall not
                          be responsible for verifying such information.
                          <br />
                          <br />
                          6.3 In case having received such monies from customers
                          and it is found that the paid amount is incorrect as a
                          result of information in Clause 6.1 of this Agreement,
                          the Company shall not be responsible for such error.
                          The Company shall not return such monies to customers,
                          the Merchant shall be solely responsible for such
                          error to its customers.
                          <br />
                          <br />
                          6.4 The Merchant acknowledges that as a risk
                          management tool, the Company and/or the Acquiring
                          Banks reserve the right to limit or restrict
                          transaction size, amount and/or monthly volume or
                          suspend the Service at any time. Further, as a
                          security measure, the Company may at its sole
                          discretion block any card number, account numbers,
                          group of cards or transactions from any specific
                          blocked or blacklisted customer cards, accounts,
                          specific, group of IP addresses, devices, geographic
                          locations and / or any such risk mitigation measures
                          it wishes to undertake.
                          <br />
                          <br />
                          6.5 The Merchant also acknowledges that the
                          arrangement between one or more Acquiring Banks and
                          Paygate may terminate at any time and services by such
                          Acquiring Banks may be withdrawn.
                        </li>
                        {/* </div> */}
                        <li>
                          6.6 The Company shall gather all the payments for
                          goods and/or services on behalf of the Merchant and,
                          after deducting of the service fee according to Clause
                          4 and any expenses (if any), remit it to the
                          Merchant’s account within the specified period and
                          according to the payment method as per the
                          application. The Merchant agrees to be responsible for
                          all fees incurred by such remittance.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            7.RESPONSIBILITIES OF THE MERCHANT
                          </b>
                          <br />
                          7.1 The Merchant has a duty to issue receipts/tax
                          invoices or any evidence of receipt to customers
                          and/or clients as prescribed by law.
                          <br />
                          <br />
                          7.2 If the Merchant intends to modify its business
                          category, payment type and/or amend the method or
                          conditions for selling of goods, engaging of services
                          or performing of works, affecting to the Company’s
                          performance of Services hereunder, the Merchant agrees
                          to notify the Company of such in writing thirty (30)
                          days in advance. In this case, the Company reserves
                          the right to charge an additional fee as proper and
                          both parties shall agree and make it in writing and
                          such document shall be deemed an integral part of this
                          Agreement.
                          <br />
                          <br />
                          7.3 The Merchant agrees that the Company is entitled
                          to set- off all amounts which the Merchant is
                          obligated to pay or refund to the Company against the
                          sum to be payable by the Company to the Merchant under
                          this Agreement without any disputes. If the amount of
                          Merchant’s account is not sufficient to set-off, the
                          Merchant agrees to pay outstanding amount to the
                          Company. In case of the Merchant fails to pay such
                          outstanding amount, the Company has the right to
                          charge an interest at the rate eighteen percent (18%)
                          per annum of outstanding amount from the due date
                          until the date on which all payments have been made in
                          full.
                          <br />
                          <br />
                          7.4 The Merchant acknowledges and agrees that in case
                          any damages or errors occur from the Company’s
                          performance of Services while the Company performing
                          in according to information as delivered by the
                          Merchant, the Merchant shall not claim any damages
                          against the Company and/or shall be solely responsible
                          for such damages or errors with its customers.
                        </li>
                        <li />
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            8.REPRESENTATIONS AND WARRANTIES
                          </b>
                          <br />
                          The Merchant represents and warrants that (a) any
                          information delivered to the Company under this
                          Agreement is correct; (b) the Merchant is engaged in a
                          lawful business that includes the sale of Goods and/or
                          Services, and duly licenses to conduct such business
                          under laws of all jurisdictions in which Merchant
                          conducts business. Merchant shall comply with all
                          laws, policies, guidelines, regulations ordinances or
                          rules applicable to Merchant’s business and this
                          Agreement; (c) all goods and/or services, which the
                          Company to receive the payments hereunder are not
                          goods and/or services prohibited by the Company’s
                          Acquiring Banks, Card Networks or prohibited by law
                          and good morals or that would expose the Company’s
                          image to risk; and (d) the Merchant shall comply with
                          all Cardholder Information Security Program, and
                          Payment Card Industry Standard (‘PCI’) requirements,
                          as amended from time to time. The Merchant must comply
                          with the Rules, including without limitation, those
                          relating to Cardholder information security issues,
                          non-disclosure of Cardholder information and
                          Transaction documents, retention and storage of
                          Cardholder and Transaction information and other
                          security procedures adopted by the Card Networks.
                          <br />
                          <br />
                          Failing of the above representations and warranties,
                          the Merchant agrees that the Company is entitled to
                          terminate this Agreement immediately and the Merchant
                          shall be responsible for all damages incurred to the
                          Company, including any loss incurred by the Merchant
                          as the result of its non-performance of this clause.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            9.MARKETING ACTIVITIES
                          </b>
                          <br />
                          9.1 The Company may advertise and publicize in
                          connection with the Services provided to the Merchant
                          and the Merchant shall provide the cooperation with
                          the Company in the advertisement and publication
                          through various media or other networks from time to
                          time as mutually agreed by both parties.
                          <br />
                          <br />
                          9.2 The Merchant agrees to advertise and publicize its
                          goods or services as well as its use of the Company’s
                          Services for receipt of payments for goods and/or
                          services of the Merchant.
                          <br />
                          <br />
                          9.3 In the case that the Merchant uses any other
                          service, method or channel for receiving of payments
                          for goods and/or services from customers or clients,
                          provided by other service provider(s) other than the
                          Company, the Merchant agrees to not act such as
                          publicizing, advertising, supporting or giving any
                          right to such service, method or channel of other
                          service provider(s) significantly or in addition to
                          doing to the Services of the Company hereunder.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>10.EXCLUSION</b>
                          <br />
                          The Merchant acknowledges and agrees that in case the
                          Services hereunder has any error or delay or has been
                          temporally suspended, arising from service connection
                          system or computer system or any relevant system or
                          virus attack or electronic equipment problems and/or
                          force majeure or any causes beyond the Company’s
                          control, the Merchant shall not definitely raise such
                          error to claim any damages against the Company and
                          shall notify the Company immediately of such error.
                          However, the Company will use its best efforts to
                          solve the problem hastily, and the Merchant agrees to
                          fully assist and cooperate with the Company in
                          resolving such problem.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            11.TERM AND TERMINATION
                          </b>
                          <br />
                          11.1 This Agreement shall be effective from the date
                          hereof for such period as specified in the
                          application. Any party who intends to terminate the
                          Agreement shall give advance written notice to the
                          other party not less than ninety (90) days prior to
                          the termination of this Agreement.
                          <br />
                          <br />
                          11.2 This Agreement shall be terminated and the
                          Company is entitled to cease the Services forthwith by
                          closing the Merchant’s user account in any one of the
                          following circumstances: (a)the Merchant uses and/or
                          declares false information;
                        </li>
                        <li>
                          (b)the Merchant is in breach of any provision of the
                          Agreement, and the Merchant does not remedy said
                          breach within fifteen (15) days upon receipt of the
                          relevant notice from the other party, then the Company
                          may immediately terminate the Agreement or, at its
                          option, suspend the performance of its obligations
                          under this Agreement until the breach is remedied; or
                          <br />
                          <br />
                          (c)either party is adjudged bankrupt or dies or ceases
                          to exist as a juristic entity or having any other
                          legitimate ground which makes either party unable to
                          comply with this Agreement, it shall be deemed that
                          this Agreement is immediately terminated.
                          <br />
                          <br />
                          Upon termination of this Agreement in any case, the
                          Merchant shall stop using the Company’s Services
                          immediately. The announcement of termination to
                          customers shall commence from the date the Services is
                          ceased and shall describe the contents that are
                          harmless to and promote both parties’ image. The
                          Company shall have the right to withheld any
                          settlement amount towards chargeback and other
                          settlement risks in accordance with the Acquiring Bank
                          and Card Network rules. This clause will not deprive
                          the Company’s right of any compensation and damages
                          due to the termination hereof by the Merchant’s acts.
                          11.3Termination of this Agreement shall not prejudice
                          nor affect the accrued rights or claims and
                          liabilities of the parties under this Agreement.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>12.TAX</b>
                          <br />
                          Each party agree that either party shall deduct
                          applicable withholding tax and/or pay Goods and
                          Services Tax (“GST”) (if any) pursuant to the
                          obligation and at the rate as prescribed by laws. The
                          Merchant shall be solely responsible for stamp duty
                          according to this Agreement (if any).
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            13.CONFIDENTIALITY
                          </b>
                          <br />
                          The parties understand that all documents, information
                          or materials produced or acquired under this Agreement
                          are confidential information and trade secrets.
                          Neither party is entitled to disclose nor cause to be
                          known by any way of such confidential information and
                          trade secrets to any third party and agrees to
                          properly keep them at any time either during and after
                          the period hereof, except for the disclosure required
                          by a court order or provisions of law or disclosure of
                          information already in public domain, developed by
                          receiving party independently and/or received from the
                          third party without breach of confidentiality.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            {" "}
                            14.INTELLECTUAL PROPERTY
                          </b>
                          <br />
                          The Company is an owner of all intellectual property
                          right, whether in contents or wording, pictures,
                          signs, logo, trade/ service marks, trade name as well
                          as all design works, in all documents and websites of
                          the Company. The Merchant must not exploit the
                          intellectual property rights of the Company or make
                          any advertisement without receiving prior written
                          consent from the Company. The Merchant shall not
                          perform or allow any third party to perform any action
                          that might cause damage to the image, trademark, trade
                          name or other intellectual property right of the
                          Company.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}> 15.AMENDMENT</b>
                          <br />
                          Unless otherwise specified herein, any amendment,
                          addition or alteration of the terms and conditions
                          under this Agreement or Application shall be made in
                          writing and executed by the duly authorized
                          representatives of both parties.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>
                            {" "}
                            16.GOVERNING LAW AND DISPUTE RESOLUTION
                          </b>
                          <br />
                          This Agreement is governed by laws of India and any
                          dispute between the Parties shall be subject to
                          exclusive jurisdiction of the Courts at Mumbai.
                        </li>
                        <li>
                          <b style={{ lineHeight: "40px" }}>17.MISCELLANEOUS</b>
                          <br />
                          17.1 The Company shall have a duty only to collect the
                          amount of payments for goods and/or services on behalf
                          of the Merchant. The Company is not involved in any
                          contracts made between the Merchant’s customers and/or
                          clients, the Merchant Merchants’ customers and/or
                          clients, and the Merchant or in any right and duty
                          among those parties. In case any disputes occur from
                          when the Merchant does not comply with the terms and
                          conditions of contracts made with its customers and/or
                          clients, the Company shall in no event be liable or
                          jointly liable. The Merchant shall be solely
                          responsible for such dispute to its customers and/ or
                          clients and keep the Company indemnified from any loss
                          or damage arising out of such dispute.
                          <br />
                          <br />
                          17.2 In no event shall the Company be responsible for
                          intentionally or negligently revealing to any other
                          persons by the Merchant of its and/or its customers’
                          bank account, credit card, username and password
                          information, or for carelessly keeping of password, or
                          in case that any other person causes to be known such
                          information or in case of dishonesty of the Merchant
                          and/or other person and the Merchant shall keep the
                          Company indemnified for any loss or damage arising out
                          of Merchant’s acts.
                          <br />
                          <br />
                          17.3 The Merchant shall provide the Services of the
                          Company in compliance with the Acquiring Banks and
                          card network policy and this Agreement, if the Company
                          finds or the Company is notified about any transaction
                          that is not correct or is under chargeback or within
                          the scope of dishonest acts in any means, the Merchant
                          agrees that the amount of such transaction will be
                          withheld or set off and remain under suspension until
                          chargeback and other investigations are over. The
                          Merchant agrees to coordinate with the Company in
                          document and information examination as requested and
                          agrees that the Company may suspend the Merchant’s
                          user account.
                          <br />
                          <br />
                          17.4 The Merchant hereby agrees and acknowledges that
                          Company may from time to time, require the Merchant to
                          maintain an interest free refundable security deposit
                          with the Company and Merchant within 7 days of receipt
                          of a written notice from the Company either arrange to
                          pay the security deposit or Paygate may withhold
                          equivalent amount from the settlement amount payable
                          to the Merchant. In the event, the Merchant fails to
                          deposit the security deposit amount within the
                          timelines specified herein or the settlement amount is
                          insufficient to withhold, the Company shall have the
                          right to terminate the performance of the Services at
                          its sole discretion, without any liability whatsoever.
                          The security deposit amount shall be reasonably
                          determined by Company to cover anticipated
                          chargebacks, returns, unshipped products and/or
                          unfulfilled services or credit risk based on the
                          Merchant’s processing history and risk assessment or
                          such amount designated by the Company.
                        </li>
                        <li>
                          17.5 The Merchant agrees that it shall not, without
                          the express written consent of the Company, as
                          appropriate, during the term of this Agreement and for
                          an additional period of six (6) months after the
                          effective date of termination of this Agreement:,
                          itself or through its successors or permitted
                          assignees, either individually or in partnership or
                          jointly or in conjunction with or for the benefit of
                          any person or entity, solicit, endeavour to solicit,
                          canvass or with any person or business who is or was a
                          customer of the Company, for the purpose of selling or
                          supplying to that person or business any products or
                          services which are competitive with the product or
                          services sold or supplied by the Company.
                          <br />
                          <br />
                          17.6 The Merchant must not assign or transfer its
                          rights, duties, benefits or claims, in whole or in
                          part, according to this Agreement to any third party
                          without the written consent from the Company. In event
                          the Merchant receives such consent; the Merchant is
                          still liable to the Company under this Agreement in
                          all respects. The Company is entitled to transfer its
                          rights, duties, benefits or claims. In whole or in
                          part, according to this Agreement to any third party
                          without consent from the Merchant.
                          <br />
                          <br />
                          17.7 Should any provision, condition, term or part of
                          this Agreement be null or invalid, the parties agree
                          that any of the valid remaining portions hereof shall
                          be deemed separate from such null or invalid parts and
                          shall remain in full force and effect.
                          <br />
                          <br />
                          17.8 In connection with the Services, the Merchant
                          agrees to execute and deliver such additional
                          documents and perform actions as may be necessary or
                          reasonably requested by the Company from time to time,
                          as the case may be, to carry out or evidence the
                          transactions carried out or contemplated under the
                          Services provided by the Company under this Agreement.
                          <br />
                          <br />
                        </li>
                      </ul>
                      <h4>
                        <b>PAYMENT SETTLEMENT PERIOD</b>
                      </h4>
                      <ul
                        style={{ listStyleType: "none", padding: 0, margin: 0 }}
                      >
                        <li>Nodal Bank (T*+1)**</li>
                        <li>*T – Transaction Day</li>
                        <li>
                          ** Settlement timeline shall be subject to the
                          regulatory guidelines and receipt of clear funds from
                          the Banks.
                        </li>
                      </ul>
                      <h4>
                        <b>TERM OF THE CONTRACT</b>
                      </h4>
                      <p>
                        Term: Three (3) Years and stands renewed automatically
                        for the same period unless terminated
                      </p>
                      <p>Minimum Term: One (1) Year</p>
                      <p style={{ pageBreakAfter: "always" }}>&nbsp;</p>
                      <h4 style={{ textAlign: "center" }}>
                        <b>FEES AND CHARGE</b>
                      </h4>
                      <div
                        className="dv-allPaymentMethods row mx-0"
                        data-aos="fade-down"
                        data-aos-duration="1000"
                        id="dv-allPaymentMethods"
                      >
                        <div className="col-lg-6">
                          <div className="dv-percentage">
                            <label>
                              1.49%<sup>*</sup>
                            </label>
                          </div>
                          <h2 className="section-heading">Domestic Payments</h2>
                          <ul className="tick">
                            <li>
                              <strong>Net Banking</strong>
                              <span>
                                SBI<sup>+</sup>, HDFC<sup>+</sup>, ICICI
                                <sup>+</sup>, Axis<sup>+</sup>, Kotak &amp; 50
                                more.
                              </span>
                            </li>
                            <li>
                              <strong>Indian Debit &amp; Credit Card</strong>
                            </li>
                            <li>
                              <strong>UPI</strong>
                              <span>
                                Google Pay, PhonePe, Paytm, BHIM &amp; other UPI
                                apps
                              </span>
                            </li>
                            <li>
                              <strong>Wallets</strong>
                              <span>
                                Amazon Pay+, Paytm, Freecharge, Mobikwik, etc
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6">
                          <div className="dv-percentage">
                            <label>
                              2.75% + <span className="rupee">5</span>
                              <sup>*</sup>
                            </label>
                          </div>
                          <h2 className="section-heading">
                            Other Payment Methods
                          </h2>
                          <ul className="tick">
                            <li>
                              <strong>Amex Card+</strong>
                            </li>
                            <li>
                              <strong>EMI+</strong>
                              <span>SBI+, HDFC+, ICICI+, Axis+, Kotak</span>
                            </li>
                            <li>
                              <strong>Pay Later+</strong>
                              <span>
                                (LazyPay, Simpl, ePayLater, Ola Money)
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <table
                        className="table borders mt-4"
                        style={{
                          width: "100%",
                          borderSpacing: 0,
                          tableLayout: "fixed",
                        }}
                      >
                        <thead style={{ backgroundColor: "#0073ccff" }}>
                          <tr>
                            <th
                              style={{
                                textAlign: "left",
                                color: "#fff",
                                width: "25%",
                              }}
                            >
                              Sr.No
                            </th>
                            <th style={{ textAlign: "left", color: "#fff" }}>
                              Particulars
                            </th>
                            <th style={{ textAlign: "left", color: "#fff" }}>
                              MDR
                            </th>
                          </tr>
                        </thead>
                        <tbody style={{ backgroundColor: "#ddebf7" }}>
                          <tr>
                            <td>1</td>
                            <td>Set Up Cost (One Time)</td>
                            <td>NA</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>AMC</td>
                            <td>NA</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Chargeback Fees (Per txn)</td>
                            <td>Rs.50 per txn</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Refund Fees (Per Txn)</td>
                            <td>Rs. 10 per txn</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Settlement Fees</td>
                            <td>Amazonpay :1.95% , other wallets :2%</td>
                          </tr>
                        </tbody>
                      </table>
                      <table
                        className="table"
                        style={{ width: "100%", borderSpacing: 0 }}
                      >
                        <tbody style={{ backgroundColor: "#ddebf7" }}>
                          <tr>
                            <td>
                              Note – Above pricing will have GST as per Govt.
                              Rules.Setup fees will be non-refundable and
                              security deposit will be refundable after 210
                              days.Settlement will be done on T+2 days basis
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {/* <p style="page-break-after: always;">&nbsp;</p> */}
                      <table style={{ width: "100%", marginTop: "20px" }}>
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>
                              PAYGATE INDIA PVT. LTD.
                            </th>
                            <th style={{ textAlign: "right" }}>Merchant</th>
                          </tr>
                        </thead>
                      </table>
                      <table style={{ width: "100%", margin: "20px 0" }}>
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}></th>
                            <th style={{ textAlign: "right" }}>
                              Agreed and signed:{" "}
                              {`${this.state.firstName} ${this.state.lastName}`}
                            </th>
                          </tr>
                        </thead>
                        {/* <thead>
                          <tr>
                            <th
                              style={{ textAlign: "left", marginTop: "20px" }}
                            >
                              Agreed and signed:{" "}
                              <span style={{ color: "white" }} />
                            </th>
                          </tr>
                        </thead> */}
                      </table>
                    </div>
                    <div
                      className="dv-bestSeller row mx-0"
                      data-aos="fade-down"
                      data-aos-duration="1000"
                      id="dv-bestSeller"
                    >
                      <div className="col-12 dv-note text-right">
                        (*) Pricing per transaction &amp; GST additional. | (+)
                        Subject to approval from banking partners.
                      </div>
                      <div className="col-12 dv-facility pl-md-5">
                        <ul className="ul-facility row mx-0">
                          <li className="col-4 py-3">No Setup fees</li>
                          <li className="col-4 py-3">
                            No Annual Maintainance fees
                          </li>
                          <li className="col-4 py-3">No fees for transfer</li>
                          <li className="col-4 py-3">
                            No fees for failed payments
                          </li>
                          <li className="col-4 py-3">No fees for refunds</li>
                          <li className="col-4 py-3">No fees for support</li>
                        </ul>
                      </div>
                    </div>

                    <p>
                      IN WITNESS WHEREOF this Agreement is made in two (2)
                      copies. The parties have thoroughly read and comprehended
                      the contents hereof and found that these correctly meet
                      their intention. The parties have consequently executed
                      and aﬃxed their company seal in the presence of witness
                      and kept on copy each.
                    </p>

                    <div className="form-group form-check mx-0 px-0">
                      <input
                        type="checkbox"
                        className="form-check-input cont-chk-inpt ml-0"
                        id="chkAgreeTC"
                        onChange={() =>
                          this.setState({ isChecked: !this.state.isChecked })
                        }
                        checked={this.state.isChecked}
                      />
                      <label
                        className="form-check-label cont-chk ml-4 pl-2"
                        htmlFor="chkAgreeTC"
                      >
                        I acknowledge that I have read, and do hereby accept the
                        terms and conditions contained in this Agreement.
                      </label>
                    </div>

                    <div className="btn-holder mt-5 text-center">
                      <button
                        type="submit"
                        className={
                          this.state.isLoaded
                            ? `btn btn-next btn-gradient disable-btn`
                            : `btn btn-next btn-gradient`
                        }
                        disabled={this.state.isLoaded || !this.state.isChecked}
                      >
                        Submit
                        {this.state.isLoaded ? (
                          <Spinner
                            size="sm"
                            color="light"
                            className="btn-loader"
                          />
                        ) : null}
                      </button>
                      {/* <a href="/success" className="btn btn-next btn-gradient">
                        Next
                      </a> */}
                    </div>
                  </div>

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline" target="_blank">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <Modal
          className="modal-dialog-centered modal-lg uploadModal contactus"
          isOpen={this.state.uploadModal}
          toggle={() => this.toggleModal("uploadModal")}
        >
          <div className="modal-body">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("uploadModal")}
            >
              <span aria-hidden={true}>×</span>
            </button>
            <div className="dv-Registration-content dv-form">
              <div className="form-group">
                <label className="section-heading">
                  Please provide us a few details so our sales team can reach
                  out to you
                </label>

                <label htmlFor="txtFirstName">
                  First Name <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="txtFirstName"
                  placeholder="Enter Name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="txtLastName">
                  Last Name <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="txtLastName"
                  placeholder="Enter Last Name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="txtEmail">
                  Email Address <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="txtEmail"
                  placeholder="Enter Email Address"
                />
              </div>
              <div className="form-group">
                <label htmlFor="txtMobile">
                  Mobile Number <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="txtMobile"
                  placeholder="Enter Mobile Number"
                />
              </div>
              <div className="form-group mt-4">
                <label htmlFor="txtCompanyName">Industry Type </label>
                <select
                  type="text"
                  className="form-control"
                  id="txtIndustryType"
                  placeholder="Eg. Safexpay"
                >
                  <option value="airlines">Airlines</option>
                  <option value="b2b">B2B</option>
                  <option value="donation">Donation</option>
                  <option value="ecommerce">Ecommerce</option>
                  <option value="education">Education</option>
                  <option value="financialservices">Financial Services</option>
                  <option value="hospitality">Hospitality</option>
                  <option value="travel">Travel</option>
                  <option value="utilities">Utilities</option>
                  <option value="other">other</option>
                </select>
              </div>
              <div className="form-group mt-4">
                <label htmlFor="txtEntityType">Entity Type </label>
                <select
                  type="text"
                  className="form-control"
                  id="txtEntityType"
                  placeholder="Eg. Safexpay"
                >
                  <option>Unregistered</option>
                  <option>Individual Proprietor</option>
                  <option>Partnership</option>
                  <option>Private Limited</option>
                  <option>Public Limited</option>
                </select>
              </div>
              <div className="form-group mt-4">
                <label htmlFor="txtCompanyName">Company Name </label>
                <input
                  type="text"
                  className="form-control"
                  id="txtCompanyName"
                  placeholder="Enter Company Name"
                />
              </div>
              <div className="form-group mt-4">
                <label htmlFor="txtCompanyName">Company Website </label>
                <input
                  type="text"
                  className="form-control"
                  id="txtCompanyName"
                  placeholder="Enter Company Website"
                />
              </div>
              <div className="form-group mt-4">
                <label htmlFor="txtCompanyName">Product Requirements</label>
                <select
                  type="text"
                  className="form-control"
                  id="txtCompanyName"
                >
                  <option>Unregistered</option>
                  <option>Individual Proprietor</option>
                  <option>Partnership</option>
                  <option>Private Limited</option>
                  <option>Public Limited</option>
                </select>
              </div>
              <div className="form-group form-check text-center my-4">
                <input
                  type="checkbox"
                  className="form-check-input cont-chk-inpt"
                  id="chkAgreeTC"
                />
                <label
                  className="form-check-label cont-chk"
                  htmlFor="chkAgreeTC"
                >
                  I agree to be contacted on the mobile number and email id
                  provided{" "}
                </label>
              </div>
              <div className="btn-holder text-center">
                <a
                  // href="/success"
                  className="btn btn-create-account btn-gradient green"
                >
                  Submit
                </a>
              </div>
              <div className="dv-bottom-bg">
                <div className="first-bottom-bg"></div>
                <div className="second-bottom-bg"></div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog-centered modal-lg loginModal"
          isOpen={this.state.loginModal}
          toggle={() => this.toggleModal("loginModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            {/* <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("loginModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button> */}
            <h5 style={{ textAlign: "center" }}>
              Session Expired, Please Login to continue
            </h5>
            <div className="btn-holder mt-3 text-center">
              <button
                onClick={this.handleLogin}
                className="btn btn-gradient bt-wd"
              >
                Login
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default AgreementDoc;
